<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="活动状态：" prop="region">
            <el-select v-model="searchForm.region" placeholder="请选择" class="mt-search-width">
              <el-option v-for="(item,index) in statusArr" :key="index" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品搜索：" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入商品名称搜索" class="mt-search-width"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="toAdd('')" size="small" type="primary" class="bg-theme">添加拼团商品</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsName"
            label="拼团名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="thumb"
            label="拼团图片">
            <template slot-scope="scope">
              <el-image
                style="width: 40px;"
                :src="scope.row.thumb"
                :preview-src-list="[scope.row.thumb]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="apiSpecPrice"
            label="日常售价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="pinTuanPrice"
            label="拼团价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="pinTuanPeopleNum"
            label="成团人数">
          </el-table-column>
          <el-table-column
            align="center"
            prop="stockNum"
            label="活动库存">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            prop="activityStartTime"
            label="活动时间">
            <template slot-scope="scope">
              <span>{{scope.row.activityStartTime+' ~ '+scope.row.activityEndTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toAdd(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { queryPinTuanGoodsPageList, removePinTuanGoodsById, enablePinTuanGoodsById } from '@/api/groupBuy'
export default {
  name: 'GroupGoods',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      baseUrl:this.$baseUrl,
      token:this.$token,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:'',
        region:''
      },
      statusArr: [{
        label:'全部',
        value:99
      },{
        label:'未开启',
        value:0
      },{
        label:'已开启',
        value:1
      }]
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let status = that.searchForm.region
      let page = that.currentPage
      queryPinTuanGoodsPageList({ goodsName: searchName, status: status, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 开启或禁用操作
    switchChangeBtn(infoId){
      let that = this
      enablePinTuanGoodsById({ id: infoId}).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {

              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removePinTuanGoodsById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 跳转添加 */
    toAdd (infoId) {
      this.$router.push({path: '/group_goods_add', query: {dataId: infoId}})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/groupBuy/GroupGoods.vue